/* eslint-disable unicorn/filename-case -- TODO rename later */
import { User } from "@istari/istari-client";

import { LabeledControlTag } from "~/api/useControlTags";
import { InternalUserType } from "~/api/user/user";
import { resolveUserDisplayNameOrUnknown } from "~/user/utils/format-user-name";

export function userToInternalUser(user: User): InternalUserType {
  const displayName = resolveUserDisplayNameOrUnknown(user);

  return {
    ...user,
    controlTags: user.controlTags?.map((tag) => ({
      ...tag,
      color: tag.displayColor,
      label: tag.name,
      value: tag.id,
    })) as LabeledControlTag[],
    fullName: displayName,
    label: displayName,
    value: user.id,
  };
}
